<template>
  <div style="padding: 20px">
    <div class="query-form">
      <el-form label-position="right" inline>
        <el-form-item label="店铺">
          <BrandSelect
            :data="vendorList"
            v-model="form.vendorId"
            filterable
            clearable
          ></BrandSelect>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.type" filterable>
            <el-option
              v-for="item in typeList"
              :label="item.label"
              :value="item.value"
              :key="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" filterable>
            <el-option
              v-for="item in statusList"
              :label="item.label"
              :value="item.value"
              :key="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          ><el-button type="primary" @click.stop="query">查询</el-button>
          <el-button @click.stop="resetQuery">重置</el-button></el-form-item
        >
      </el-form>
    </div>

    <el-table class="myTable" :data="tableData">
      <el-table-column
        prop="vendorName"
        label="店铺"
        min-width="120"
      ></el-table-column>
      <el-table-column prop="includingTax" label="是否含税" min-width="100">
        <template slot-scope="scope">
          {{
            scope.row.includingTax === 1
              ? "含税"
              : scope.row.includingTax === 2
              ? "不含税"
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column prop="typeName" label="类型" min-width="120">
      </el-table-column>
      <el-table-column prop="statusName" label="状态" min-width="120">
      </el-table-column>
      <el-table-column prop="" label="时间" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.beginTime }}
          -
          {{ scope.row.endTime }}
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="操作人"></el-table-column>
      <el-table-column label="操作" width="330" prop="">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">配置</el-button>
          <el-button type="text" @click="showFileList(scope.row)"
            >历史配置文件</el-button
          >
          <el-button
            type="text"
            v-if="
              (scope.row.ruleId && scope.row.status === 1) ||
              scope.row.status === 0
            "
            @click="invalidSupplyPrice(scope.row)"
            >失效</el-button
          >
          <div
            class="upload-wrap"
            v-if="(scope.row.type === 2 || scope.row.type === 3) && scope.row.status === 1"
          >
            <el-button type="text">增量上传价格文件</el-button>
            <input
              @change="(e) => changeFile(e, scope.row)"
              accept=".xlsx"
              type="file"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: right; margin: 20px 0; padding-bottom: 20px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[15, 25, 30, 50]"
      :page-size="pageSize"
      layout="total, prev, pager, next,sizes, jumper"
      :total="total"
    ></el-pagination>
    <el-dialog
      title="配置"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div style="width: 96%; margin: 0 auto">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          :rules="rules"
          label-width="100px"
          label-position="left"
          class="demo-ruleForm"
        >
          <el-form-item label="类型：" prop="type">
            <el-radio-group v-model="ruleForm.type" @change="changeType">
              <el-radio :label="item.value" v-for="item in typeList">{{
                item.label
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="导入文件："
            prop="fileUrl"
            v-if="ruleForm.type == 2 || ruleForm.type == 3"
          >
            <div
              style="padding-bottom: 6px; color: red; font-weight: bold"
              v-if="ruleForm.type == 2"
            >
              该店铺为<span style="font-size: 16px; padding: 0 4px">
                {{ includingTaxName }}</span
              >店铺，需要导入<span style="font-size: 16px; padding: 0 4px">{{
                includingTaxName
              }}</span
              >供货价！！！
            </div>
            <el-upload
              class="upload-demo"
              action=""
              :http-request="handleHttpRequest"
              accept=".xls, .xlsx, .XLS, .XLSX"
              :on-success="handleSuccess"
              :on-exceed="handleExceed"
              :on-remove="onRemove"
              :file-list="fileList"
              :limit="limit"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" style="display: inline-block; margin-left: 30px">
                <i
                  class="el-icon-download"
                  style="color: #409eff; padding-right: 2px"
                ></i
                ><a
                  :href="
                    ruleForm.type == 2
                      ? 'https://product-sts.oss-cn-shanghai.aliyuncs.com/tmp/17587072683140.2016689399240028.xlsx'
                      : ruleForm.type == 3
                      ? 'https://product-sts.oss-cn-shanghai.aliyuncs.com/tmp/ca7ff921-f432-40ca-8451-9842f9eeecc0.xlsx'
                      : ''
                  "
                  >点击下载模板</a
                >
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="生效时间：" prop="beginTime">
            <el-date-picker
              v-model="ruleForm.beginTime"
              type="datetime"
              placeholder="选择生效时间"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              :disabled="ruleForm.status == 1 ? true : false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="失效时间：" prop="endTime">
            <el-date-picker
              v-model="ruleForm.endTime"
              type="datetime"
              placeholder="选择失效时间"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="折扣："
            v-if="ruleForm.type == 1"
            prop="discount"
          >
            <el-input
              type="number"
              v-model="ruleForm.discount"
              style="width: 220px"
              ><template slot="append">%</template></el-input
            >
            <span style="padding-left: 20px; color: red; font-weight: bold"
              >当前使用中国折扣显示,如70%代表价格=日常供货价格*70%。</span
            >
          </el-form-item>
          <div v-if="ruleForm.type == 1">
            <el-card
              v-for="(item, index) in ruleForm.scopes"
              :key="item"
              class="box-card"
              style="margin-bottom: 10px"
            >
              <div slot="header" class="clearfix">
                <span>规则 {{ index + 1 }}</span>
                <el-button
                  style="float: right; padding: 8px"
                  type="danger"
                  icon="el-icon-minus"
                  circle
                  v-if="ruleForm.scopes.length > 1"
                  @click="removeScope(index)"
                ></el-button>
                <el-button
                  style="float: right; padding: 8px; margin: 0 10px"
                  type="primary"
                  icon="el-icon-plus"
                  circle
                  v-if="index == ruleForm.scopes.length - 1"
                  @click="addScope"
                ></el-button>
              </div>
              <el-form-item label="品牌：" prop="brandIds">
                <div style="display: flex">
                  <BrandSelect
                    :disabled="item.checkedBrandIds"
                    :data="brandNameList"
                    v-model="item.brandNames"
                    multiple
                    filterable
                    clearable
                  ></BrandSelect>
                  <el-checkbox
                    v-model="item.checkedBrandIds"
                    @change="changeAll(index, 1)"
                    style="padding-left: 10px"
                    >全选</el-checkbox
                  >
                </div>
              </el-form-item>
              <el-form-item label="类目：" prop="categoryIds">
                <div style="display: flex">
                  <el-cascader
                    :disabled="item.checkedCategoryIds"
                    v-model="item.categoryIds"
                    :options="categoryList"
                    :props="optionProps"
                    clearable
                    :style="{ flex: 1 }"
                  ></el-cascader>

                  <el-checkbox
                    v-model="item.checkedCategoryIds"
                    @change="changeAll(index, 2)"
                    style="padding-left: 10px"
                    >全选</el-checkbox
                  >
                </div>
              </el-form-item>
              <el-form-item label="季节：" prop="seasonCodes">
                <div style="display: flex">
                  <BrandSelect
                    :disabled="item.checkedSeasonCodes"
                    :data="seasonList"
                    v-model="item.seasonCodes"
                    multiple
                    filterable
                    clearable
                  ></BrandSelect>
                  <el-checkbox
                    v-model="item.checkedSeasonCodes"
                    @change="changeAll(index, 3)"
                    style="padding-left: 10px"
                    >全选</el-checkbox
                  >
                </div>
              </el-form-item>
            </el-card>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitDialog">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="历史配置文件"
      :visible.sync="dialogVisible2"
      width="50%"
      :before-close="handleClose2"
      :close-on-click-modal="false"
    >
      <div style="width: 96%; margin: 0 auto">
        <el-table :data="fileTableData">
          <el-table-column prop="" label="价格文件" min-width="180">
            <template slot-scope="scope">
              <el-button type="text" @click="download(scope.row)">{{
                scope.row.fileName
              }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型" min-width="120">
            <template slot-scope="scope">
              {{
                scope.row.type === 1
                  ? "全量"
                  : scope.row.type === 2
                  ? "增量"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="上传时间" min-width="120">
          </el-table-column>
          <el-table-column
            prop="operationUser"
            label="操作人"
          ></el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin: 20px 0; padding-bottom: 20px"
          background
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="fileParams.pageNo"
          :page-sizes="[15, 25, 30, 50]"
          :page-size="fileParams.pageSize"
          layout="total, prev, pager, next,sizes, jumper"
          :total="total2"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from "@/utils/util";
import { downloadFile } from "@/utils/functions";
import {
  getSupplyPriceRuleList,
  queryNewVendorList,
  downloadFileUrl,
  getSupplyPriceRuleDetail,
  saveSupplyPriceRule,
  invalidSupplyPriceRule,
  appendSku,
  getSkuFileList,
} from "../api.js";
import {
  fileUpload,
  getBrandList,
  category,
  seasonList,
} from "@/api/merchants_cn";
import Client from "@/utils/client.js";

import BrandSelect from "@/views/components/brandSelect.vue";

export default {
  data() {
    var validator = (rule, value, callback) => {
      if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        callback(new Error("仅允许输入20—99的整数数字，请修改"));
      } else if (Number(value) < 20 || Number(value) > 99) {
        callback(new Error("仅允许输入20—99的整数数字，请修改"));
      } else {
        callback();
      }
    };

    return {
      vendorList: [],
      cities: [],
      activityName: "",
      form: {
        vendorId: "",
        type: "",
        status: "",
      },
      currentPage: 1,
      pageSize: 15,
      total: 0,
      ruleForm: {},
      rules: {
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        endTime: [
          { required: true, message: "请选择失效时间", trigger: "change" },
        ],
        beginTime: [
          { required: true, message: "请选择生效时间", trigger: "change" },
        ],
        fileUrl: [{ required: true, message: "请上传文件", trigger: "change" }],
        discount: [{ required: true, validator: validator, trigger: "blur" }],
      },
      dialogVisible: false,
      dialogVisible2: false,
      tableData: [],
      brandList: [],
      brandNameList: [],
      categoryList: [],
      optionProps: {
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: true,
      },
      seasonList: [],
      pickerOptions: {
        disabledDate: (val) => {
          return val.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
        },
      },
      includingTaxName: "",

      fileList: [],
      limit: 1,
      fileTableData: [],
      fileParams: {
        pageSize: 25,
        pageNo: 1,
        vendorId: "",
      },
      total2: 0,
      typeList: [
        { label: "圈品", value: 1 },
        { label: "指定商品", value: 2 },
        { label: "指定商品折扣", value: 3 },
      ],
      statusList: [
        { label: "待生效", value: 0 },
        { label: "生效中", value: 1 },
        { label: "失效", value: 2 },
      ],
    };
  },
  components: { BrandSelect },
  created() {},
  mounted() {
    queryNewVendorList({
      supplyPriceMethod: 1,
      includeVendorTypes: [0, 2],
    }).then((res) => {
      this.vendorList = ((res.data && res.data.data) || []).map((item) => {
        return {
          label: item.vendorName,
          value: item.vendorId,
        };
      });
    });
    getBrandList().then((res) => {
      this.brandList = (res.data || []).map((item) => ({
        label: item.englishName,
        value: item.brandId,
      }));
      this.brandNameList = (res.data || []).map((item) => ({
        label: item.englishName,
        value: item.englishName,
      }));
    });
    category().then((res) => {
      if (res && res.data) {
        this.categoryList = Object.freeze(this.gatherCategory(res.data));
      }
    });

    seasonList().then((res) => {
      this.seasonList = (res.data || []).map((item) => ({
        label: item.chineseName,
        value: item.seasonCode,
      }));
    });
    this.query();
  },
  methods: {
    gatherCategory(items) {
      if (Array.isArray(items)) {
        return items.map((item) => {
          let newItem = {
            label: item.chineseName,
            value: item.categoryId,
          };
          if (Array.isArray(item.children)) {
            newItem.children = this.gatherCategory(item.children);
          }
          return newItem;
        });
      } else {
        return items;
      }
    },
    query() {
      this.currentPage = 1;
      this.getTableData();
    },
    resetQuery() {
      this.form.vendorId = "";
      this.form.type = "";
      this.form.status = "";
      this.currentPage = 1;
      this.getTableData();
    },
    handleClose() {
      this.$refs["ruleForm"].resetFields();
      this.dialogVisible = false;
    },
    handleClose2() {
      this.dialogVisible2 = false;
    },
    async getTableData() {
      let targetObj = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        vendorId: this.form.vendorId,
        type: this.form.type,
        status: this.form.status,
      };
      this.$store.commit("setPageLoading", true);
      let resData = await getSupplyPriceRuleList(targetObj);
      this.$store.commit("setPageLoading", false);
      if (!resData.data) {
        this.$message.error(`${resData.message}`);
        return;
      }
      let { total, list } = resData.data;
      this.total = total;
      list.forEach((item) => {
        item.beginTime = item.beginTime
          ? utils.dateFormat(new Date(item.beginTime), "yyyy-MM-dd hh:mm")
          : "";
        item.endTime = item.endTime
          ? utils.dateFormat(new Date(item.endTime), "yyyy-MM-dd hh:mm")
          : "";
        (item.typeName = (
          this.typeList.find((t) => t.value == item.type) || { label: "" }
        ).label),
          (item.statusName = (
            this.statusList.find((t) => t.value == item.status) || { label: "" }
          ).label);
      });
      this.tableData = list;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    download(row) {
      downloadFileUrl(row.fileUrl).then((res) => {
        downloadFile(res.data, row.fileName);
      });
    },
    async edit(row) {
      var res = await getSupplyPriceRuleDetail({
        ruleId: row.ruleId,
        vendorId: row.vendorId,
      });
      this.dialogVisible = true;
      if (res.success && res.data) {
        let {
          vendorId,
          vendorName,
          includingTax,
          type,
          status,
          beginTime,
          endTime,
          userName,
          fileUrl,
          fileName,
          scopes,
          discount,
        } = res.data;
        let newScopes = (
          scopes || [{ brandIds: [], categoryIds: [], seasonCodes: [] }]
        ).map((item) => {
          let { brandIds = [], categoryIds = [], seasonCodes = [] } = item;
          let newBrandIds = [...brandIds];
          if (brandIds && brandIds.length && brandIds[0] == 0) {
            newBrandIds = [];
          }
          let brandNames = this.brandList
            .filter((brand) => newBrandIds.indexOf(brand.value) > -1)
            .map((i) => {
              return i.label;
            });
          return {
            brandIds: newBrandIds,
            brandNames: brandNames,
            categoryIds:
              categoryIds && categoryIds.length && categoryIds[0] == 0
                ? []
                : categoryIds,
            seasonCodes:
              seasonCodes && seasonCodes.length && seasonCodes[0] == 0
                ? []
                : seasonCodes,
            checkedBrandIds:
              brandIds && brandIds.length && brandIds[0] == 0 ? true : false,
            checkedCategoryIds:
              categoryIds && categoryIds.length && categoryIds[0] == 0
                ? true
                : false,
            checkedSeasonCodes:
              seasonCodes && seasonCodes.length && seasonCodes[0] == 0
                ? true
                : false,
          };
        });
        this.$nextTick(() => {
          this.includingTaxName =
            includingTax === 1 ? "含税" : includingTax === 2 ? "不含税" : "";
          this.ruleForm = {
            ruleId: row.ruleId,
            vendorId,
            vendorName,
            includingTax,
            type,
            status,
            beginTime: beginTime
              ? utils.dateFormat(new Date(beginTime), "yyyy-MM-dd hh:mm")
              : utils.dateFormat(new Date(), "yyyy-MM-dd hh:mm"),
            endTime: endTime
              ? utils.dateFormat(new Date(endTime), "yyyy-MM-dd hh:mm")
              : utils.dateFormat(new Date(), "yyyy-MM-dd hh:mm"),
            userName,
            fileUrl: "",
            fileName: "",
            scopes: newScopes,
            discount,
          };
        });
        this.fileList = [];
        // if (fileUrl && fileName) {
        //   this.fileList = [
        //     {
        //       name: fileName,
        //       url: fileUrl,
        //     },
        //   ];
        // } else {
        //   this.fileList = [];
        // }
      } else {
        this.$message.error(res.message || "查询失败");
      }
    },
    handleExceed(files, fileList) {
      this.$message.error(`仅限选择 ${this.limit} 个文件`);
    },
    onRemove(files, fileList) {
      this.ruleForm.fileUrl = null;
      this.ruleForm.fileName = null;
      this.fileList = [];
    },
    handleSuccess(res, file, fileList) {
      this.ruleForm.fileUrl = fileList[0].response.url.replace(
        "http://",
        "https://"
      );
      this.ruleForm.fileName = fileList[0].name;
      this.$refs.ruleForm.clearValidate("fileUrl");
    },
    handleHttpRequest(option) {
      return fileUpload().then((res) => {
        const client = Client(res.data.data),
          file = option.file;
        const random_name =
          new Date().getTime() +
          Math.random().toString() +
          "." +
          file.name.split(".").pop();
        return client.put("tmp/" + random_name, file);
      });
    },
    changeAll(index, code) {
      if (code == 1) {
        this.ruleForm.scopes[index].brandIds = [];
        this.ruleForm.scopes[index].brandNames = [];
      } else if (code == 2) {
        this.ruleForm.scopes[index].categoryIds = [];
      } else if (code == 3) {
        this.ruleForm.scopes[index].seasonCodes = [];
      }
    },
    submitDialog() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        var { ruleForm } = this;
        var params = {
          ...ruleForm,
          beginTime: new Date(ruleForm.beginTime + ":00").getTime(),
          endTime: new Date(ruleForm.endTime + ":00").getTime(),
          userName: localStorage.getItem("userName"),
        };
        var flage = false;
        if (params.type == 2 || params.type == 3) {
          params.scopes = [];
        } else if (params.type == 1) {
          params.fileUrl = null;
          params.fileName = null;
          params.scopes = ruleForm.scopes.map((item) => {
            item.brandIds = this.brandList
              .filter((brand) => item.brandNames.indexOf(brand.label) > -1)
              .map((i) => {
                return i.value;
              });
            var newItem = {
              brandIds: item.checkedBrandIds ? [0] : item.brandIds,
              categoryIds: item.checkedCategoryIds ? [0] : item.categoryIds,
              seasonCodes: item.checkedSeasonCodes ? [0] : item.seasonCodes,
            };
            if (
              !newItem.brandIds.length ||
              !newItem.categoryIds.length ||
              !newItem.seasonCodes.length
            ) {
              flage = true;
            }
            return newItem;
          });
        }
        if (flage) {
          this.$message.error("请补全品牌、类目、季节！");
          return;
        }
        this.$confirm(`确认提交`, "确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.saveSupplyPriceRule(params);
          })
          .catch(() => {});
      });
    },
    saveSupplyPriceRule(params) {
      this.$store.commit("setPageLoading", true);
      saveSupplyPriceRule(params).then((res) => {
        this.$store.commit("setPageLoading", false);
        if (res.success) {
          this.$message.success("操作成功！");
          this.dialogVisible = false;
          this.getTableData();
        } else {
          if ((res.code = 1001 && res.data)) {
            this.$message.error(res.message + ",已自动下载");
            let url = res.data.replace("http:", "https:");
            downloadFileUrl(url).then((resP) => {
              downloadFile(resP.data, "错误文件.xlsx");
            });
          } else {
            this.$message.error(res.message || "操作失败");
          }
        }
      });
    },
    invalidSupplyPrice(row) {
      this.$confirm(`确认操作：失效?`, "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.commit("setPageLoading", true);
          invalidSupplyPriceRule({
            ruleId: row.ruleId,
          }).then((res) => {
            this.$store.commit("setPageLoading", false);
            if (res.success) {
              this.$message.success("操作成功");
              this.getTableData();
            } else {
              this.$message.error(res.message || "操作失败");
            }
          });
        })
        .catch(() => {});
    },
    changeType(val) {
      if (val == 2) {
        this.$message.warning("选择指定商品后圈品规则将会失效");
      }
      if (val == 3) {
        this.$message.warning("选择指定商品折扣后圈品规则将会失效");
      }
    },
    addScope() {
      this.ruleForm.scopes.push({
        brandIds: [],
        brandNames: [],
        categoryIds: [],
        seasonCodes: [],
        checkedBrandIds: false,
        checkedCategoryIds: false,
        checkedSeasonCodes: false,
      });
    },
    removeScope(index) {
      this.ruleForm.scopes.splice(index, 1);
    },
    async changeFile(e, row) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (!/\.xlsx$/.test(String(file.name).toLowerCase())) {
          this.$message.error("上传文件格式非法，请上传xlsx文件");
          return;
        }
        if (file.size > 10 * 1024 * 1024) {
          this.$message.error("文件最大10m");
          return;
        }
        this.$store.commit("setPageLoading", true);
        const confRes = await fileUpload();
        const OSSClient = Client(confRes.data.data);
        const fileName =
          this.random_string(6) +
          "_" +
          new Date().getTime() +
          "." +
          file.name.split(".").pop();
        const random_name = "tmp/" + fileName;
        const resFile = await OSSClient.put(random_name, file);
        var params = {
          vendorId: row.vendorId,
          ruleId: row.ruleId,
          fileName: file.name,
          fileUrl: resFile.url.replace("http://", "https://"),
        };
        const res = await appendSku(params);
        this.$store.commit("setPageLoading", false);
        if (res.success) {
          this.getTableData();
          this.$message.success("导入成功");
        } else {
          if ((res.code = 1001 && res.data)) {
            this.$message.error(res.message + ",已自动下载");
            let url = res.data.replace("http:", "https:");
            downloadFileUrl(url).then((resP) => {
              downloadFile(resP.data, "错误文件.xlsx");
            });
          } else {
            this.$message.error(res.message || "系统异常");
          }
        }
      }
      e.target.value = "";
    },
    random_string(len) {
      len = len || 32;
      let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678",
        maxPos = chars.length,
        pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    showFileList(row) {
      this.fileParams = {
        pageSize: 25,
        pageNo: 1,
        vendorId: row.vendorId,
      };
      this.fileTableData = [];
      this.dialogVisible2 = true;
      this.getFileList();
    },
    async getFileList() {
      var fileParams = this.fileParams;
      this.$store.commit("setPageLoading", true);
      let resData = await getSkuFileList(fileParams);
      this.$store.commit("setPageLoading", false);
      if (!resData.data) {
        this.$message.error(`${resData.message}`);
        return;
      }
      let { total, list } = resData.data;
      this.total2 = total;
      list.forEach((item) => {
        item.createdAt = item.createdAt
          ? utils.dateFormat(new Date(item.createdAt), "yyyy-MM-dd hh:mm")
          : "";
      });
      this.fileTableData = list;
    },
    handleSizeChange2(val) {
      this.fileParams.pageSize = val;
      this.fileParams.pageNo = 1;
      this.getFileList();
    },
    handleCurrentChange2(val) {
      this.fileParams.pageNo = val;
      this.getFileList();
    },
  },
};
</script>
<style lang="less" scoped>
.dialogContainer .el-checkbox {
  margin-left: 0;
  margin-right: 20px;
  margin-bottom: 5px;
}
.manipulate {
  margin-right: 12px;
  color: #409eff;
  cursor: pointer;
}
.dot {
  display: inline-block;
  margin-right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.gray {
  background: #cccccc;
}
.green {
  background: green;
}
.dropdown-item {
  margin: 0;
  padding: 7px 16px;
  clear: both;
  color: #657180;
  font-size: 12px !important;
  white-space: nowrap;
  list-style: none;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}
.demo-ruleForm {
  margin: 20px 0px;
}
.flex {
  height: 80px;
  padding-top: 13px;
  padding-left: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
}
.absolute {
  position: absolute;
  top: 0;
  left: 168px;
}
.upload-wrap {
  position: relative;
  display: inline-block;
  margin-left: 10px;

  input {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 10;
  }
}
</style>
